import { Component, Input } from "@angular/core"

@Component({
    selector: "app-icon",
    templateUrl: "./icon.component.html",
    styleUrls: ["./icon.component.less"],
})
export class IconComponent {
    @Input() public type: string

    public getIcon() {
        return IconComponent.getIconFor(this.type)
    }

    public static getIconFor(type) {
        switch (type) {
            case "Audio":
                return "icon-audio"
            case "Video":
                return "icon-video"
            case "Image":
                return "icon-image"
            case "Document":
                return "icon-document"
            case "Interactive":
                return "icon-interactive"
            case "Interactive Lesson":
            case "Interactive+Lesson":
                return "icon-interactive-lesson"
            case "Webpage":
                return "ico-website"
            case "Collection":
                return "icon-collection"
            case "Media Gallery":
            case "Media+Gallery":
                return "icon-media-gallery"
            case "Self-Paced Lesson":
                return "fas fa-clipboard fa-lg"
            case "Lesson Plan":
            case "Lesson+Plan":
                return "icon-lesson-plan"
            case "Bookmark":
                return "far fa-heart"
            case "Bookmark-filled":
                return "fas fa-heart"
            case "Info":
                return "ico-info"
            case "Lightbulb":
                return "ico-lightbulb"
            case "Arrow-left":
                return "icon-arrow-left"
            case "Arrow-right":
                return "icon-arrow-right"
            case "Arrow-down":
                return "icon-arrow-down"
            case "Arrow-right2":
                return "fas fa-arrow-right"
            case "Arrow-left2":
                return "fas fa-arrow-left"
            case "Trash":
                return "far fa-trash-alt fa-lg"
            case "User":
                return "fas fa-user-circle fa-lg"
            case "Search":
                return "fas fa-search fa-lg"
            case "Menu":
                return "icon-menu"
            case "X":
                return "fas fa-times fa-lg"
            case "Expand":
                return "fas fa-expand-arrows-alt fa-lg"
            case "Eye":
                return "fas fa-eye fa-lg"
            case "Facebook":
                return "fab fa-facebook fa-lg"
            case "Facebook-square":
                return "fab fa-facebook-square fa-lg"
            case "Google":
                return "fab fa-google fa-lg"
            case "Twitter":
                return "fab fa-twitter fa-lg"
            case "Pinterest":
                return "fab fa-pinterest fa-lg"
            case "Print":
                return "fas fa-print fa-lg"
            case "Word":
                return "far fa-file-word fa-lg"
            case "Share":
                return "icon-share-and-assign"
            case "AssignClass":
                return "lmbase-teacher"
            case "Email":
                return "icon-email"
            case "Code":
                return "icon-link"
            case "SocialMedia":
                return "icon-social-any"
            case "Exclamation":
                return "fas fa-exclamation"
            case "Favorite":
                return "icon-favorite"
            case "FavoriteFilled":
                return "icon-favorited"
            case "SupportMaterials":
                return "icon-support-materials"
            case "Standards":
                return "icon-standards"
            case "Assignments":
                return "icon-assignments"
            case "Puzzle":
                return "icon-puzzle"
            case "Dashboard":
                return "icon-dashboard"
            case "Link":
                return "fas fa-link"
            case "External-link":
                return "fas fa-external-link-alt"
            case "Check":
                return "fas fa-check"
            case "Plus":
                return "fas fa-plus"
            case "Minus":
                return "fas fa-minus"
            case "Exclamation-triangle":
                return "fas fa-exclamation-triangle"
            case "FacebookSecondVersion":
                return "fab fa-facebook-f"
            case "Pencil":
                return "fas fa-pencil-alt"
            case "Cog":
                return "fas fa-cog"
            case "Close":
                return "icon-close"
            default:
                return "fas fa-file fa-lg"
        }
    }
}
